<template>
  <div>
    <textarea ref="article" :name="name" :placeholder="placeholder" :value="value"></textarea>
  </div>
</template>
<script>
import ArticleEditor from '../../../app/vendors/article-editor/article-editor.usm.min.js'

export default {
  article: false,
  props: {
    value: {
      default: '',
      type: String,
    },
    contentEditor: {
      default: '',
      type: String,
    },
    placeholder: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      default: null,
    },
    config: {
      default: () => {},
      type: Object,
    },
  },
  data() {
    return {
      content: this.value
    }
  },
  mounted() {
    this.init()
  },
  beforeDestroy() {
    this.destroy()
  },
  methods: {
    init() {
      const me = this
      const subscribe = {
        'editor.content.change': function (event) {
          const html = event.get('html')
          me.handleInput(html)
          return html
        },
      }

      this.config.editor.focus = false

      // extend config
      this.$set(this.config, 'subscribe', subscribe)

      // call
      const app = ArticleEditor(this.$refs.article, this.config)

      // set instance
      this.article = app
      this.$parent.article = app
    },
    destroy() {
      // Call destroy on article to cleanup event handlers
      this.article.stop()

      // unset instance for garbage collection
      this.article = null
      this.$parent.article = null
    },
    handleInput(val) {
      this.$emit('input', val)
    },
  },
}
</script>

